<template>
  <div class="content">
    <template v-if="index === '1'">
      <div class="h3-title">订购提示</div>
      <div class="item">
        1、鉴于文体演出票品特殊性，一旦订单支付／付款成功，概不支持退换。如果配票失败或不可抗力因素导致演出取消，我们将全额退还。
      </div>
      <div class="item">
        2、节目详情及相关内容介绍仅供参考，具体以主办方公布信息及现场为准，必要时请于观演日当天提前到场，以免错过节目开演时机。
      </div>
      <div class="item">
        3、儿童需持票入场，部分节目1.2米以下儿童谢绝入场。具体以主办公布信息及票根为准。
      </div>
    </template>
    <template v-else-if="index === '2'">
      <div class="h3-title">订购说明</div>
      <div class="h4-title">订票服务条款</div>
      <div class="">
        详见<span class="text-bottom" @click="navGate">《服务条款说明》</span>
      </div>
      <div class="h4-title margin-top">订单管理帮助</div>
      <div class="h4-title">1、什么是订单</div>
      <div class="item">
        订单是订购商品的合同、单据，又称为订货单，每个订单会有一个订单号，您可以在“我的订单”中查看、追踪订单，并可对订单做付款、取消等操作。
      </div>
      <div class="h4-title margin-top">2、订单各个状态的解释：</div>
      <div class="item margin-bottom">
        <span class="item_title font-weight">交易取消：</span
        >您自行取消的交易或您没有在指定时间内支付订单，导致系统自动取消交易
      </div>
      <div class="item margin-bottom">
        <span class="item_title font-weight">交易成功：</span
        >货款两清后的订单状态
      </div>
      <div class="item margin-bottom">
        <span class="item_title font-weight">待支付：</span
        >需要付款才能继续交易时的订单状态
      </div>
      <div class="item margin-bottom">
        <span class="item_title font-weight">配送中／出票中：</span
        >工作人员正在准备商品和打包商品时的订单状态
      </div>
      <div class="item margin-bottom">
        <span class="item_title font-weight">已发货：</span
        >表示商品打包完毕并寄送时的订单状态
      </div>
      <div class="item margin-bottom">
        <span class="item_title font-weight">退款中：</span
        >正在办理退款和款项在到贵账户途中时的订单状态
      </div>
      <div class="item margin-bottom">
        <span class="item_title font-weight">退款成功：</span
        >退款完成后的订单状态
      </div>
    </template>
    <template v-if="index === '3'">
      <div class="h3-title">支付方式</div>
      <div class="item">
        纷玩岛APP购票同时支持微信、支付宝支付；纷玩岛微信小程序支持微信支付。您可在提交订单后，选择任一方式完成支付。
      </div>
    </template>
    <template v-else-if="index === '4'">
      <div class="h3-title">售后服务</div>
      <div class="h4-title margin-top">缺货说明</div>
      <div class="item">
        由于票品数量有限，订票客户非常踊跃，致使某些演出场次或票价出现缺货现象。一旦您缺货登记成功，我们会记录下来，如有新增票源，我们将依据票量和登记先后顺序进行部分客户的短信通知。如始终缺货，将不再另行通知。建议您优先考虑现有票的场次。
      </div>
      <div class="h4-title margin-top">退款说明</div>
      <div class="item">
        如果在纷玩岛购买并在线支付发生需要退款的情况，我们将通过用户购票时选择的支付通道原路退还给用户。一般情况下，纷玩岛在确认退款后的三个工作日内发起原路退还，实际到账时间由支付通道决定。
      </div>
      <div class="h4-title margin-top">短信帮助</div>
      <div class="font-weight">
        当您未收到纷玩岛短信时，请您确认以下几个步骤：
      </div>
      <div class="item">
        1、手机号码输入是否正确，并且与纷玩岛绑定的手机是否为同一手机号码；
      </div>
      <div class="item">
        2、以下情况可能会导致短信被拦截：（1）部分机型自带拦截功能；（2）安装了手机安全软件，如360手机卫士、金山卫士等。请先关闭相关功能，然后再次尝试。
      </div>
      <div class="item">
        3、现时网络是否正常。短信在并发比较高的时段有可能会出现几分钟的延迟；
      </div>
      <div class="item">
        注：如您的问题仍然存在，请您将手机号码提供给客服人员，客服人员会为您解决。
      </div>
    </template>
    <template v-if="index === '5'">
      <div class="h3-title">关于我们</div>
      <div class="item">
        成立于2019年，系上海华人文化演艺有限公司旗下全资子公司，是一家致力于票务管理的综合服务型公司。公司以稳重为主导，结合线上平台建设和线下整合营销，为客户提供全方位精准的票务销售系统。
        公司以理解客户的需求为宗旨，以服务为核心导向，以适应市场发展为品牌竞争力，汇集票务售卖、票务统计、演出宣发、票仓归纳等相关领域的精英，组建专业的团队。同时，公司倡导“策略+执行”一站式的服务方式。
      </div>
    </template>
  </div>
</template>

<script>
import "./rem";
export default {
  data() {
    return {
      index: this.$route.query.index,
    };
  },
  methods: {
    navGate() {
      this.$router.push({
        path: "/problem/appTypeDetail",
      });
    },
  },
  created() {},

  mounted() {},
};
</script>
<style lang="scss" scoped>
.content {
  padding: 20px 20px;
  font-size: 12px;
  background: #f6f6f6;
  min-height: calc(100vh - 40px);
  color: #333;
}
.margin-top {
  margin-top: 15px;
}
.margin-bottom {
  margin-bottom: 10px;
}
.h3-title {
  font-weight: 500;
  font-size: 17px;
  margin-bottom: 15px;
}
.h4-title {
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 15px;
}
.font-weight {
  font-weight: bold;
}
.text-bottom {
  color: #00a0e9;
  text-decoration: underline;
}
</style>
